import defaultOptions from "./popup-default-options.json";
import addBlocks from "./blocks/blocks-index.js";
import addComponents from "./components/components-index.js";

const customPopup = (editor, opts = {}) => {
  const options = { ...defaultOptions, ...opts };

  addComponents(editor, options);
  addBlocks(editor, options);
}

export default customPopup;